"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "hash": "7b41b42",
    "raw": "v3.19.0",
    "semverString": "3.19.0"
};
//# sourceMappingURL=version.js.map